import React from 'react';
import { Content, Dialog, DialogContainer, Divider, Heading } from '@adobe/react-spectrum';
import '../common/searedDialog/searedDialog.css';
import { SearedLoader } from './SearedLoader';

/**
 * Full-screen modal wrapping SearedLoader. Use when the load blocks the
 * entire page (deck import, route-level fetch). For embedded section
 * loads (pane, card), use SearedLoader directly instead.
 */
export function GenericLoadingDialog({ caption, title, eyebrow, subcaption }) {
    return (
        <DialogContainer type={'modal'} isDismissable={false} onDismiss={() => {}}>
            <Dialog width={'calc(100vw - 40px)'} maxWidth={420} UNSAFE_className="searedDialog">
                <Heading>
                    <span className="searedDialog__eyebrow">{eyebrow || 'Working'}</span>
                    <span className="searedDialog__title">{title || 'Loading deck...'}</span>
                </Heading>
                <Divider />
                <Content>
                    <SearedLoader
                        caption={caption}
                        subcaption={subcaption || 'Hold tight — fresh salt takes a moment.'}
                    />
                </Content>
            </Dialog>
        </DialogContainer>
    );
}
